import React, { useState } from "react";

import img1 from '../assets/uploads/2015/07/divine-wellness-mohali.jpg';
import img2 from '../assets/uploads/2015/07/divine-wellness-yoga-mohali-768x328.jpg';
import img3 from '../assets/uploads/2018/10/divine-classes-1024x768.jpeg';
import img4 from '../assets/uploads/2018/10/About-us-divine-wellness.jpg';
import img5 from '../assets/uploads/2018/10/divine-yoga-group-1024x768.jpeg';
import img6 from '../assets/uploads/2018/10/divine-sewa-443x590.jpeg';
import img7 from '../assets/uploads/2018/10/divine-yoga-classes-640x585.jpeg';

const images = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
];

const videos = [

];

function Gallery() {
  const [modalImg, setModalImg] = useState(null);
  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-8 text-green-800">Gallery</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {images.map((img, i) => (
          <img
            key={img}
            src={img}
            alt={`Gallery ${i+1}`}
            className="rounded shadow cursor-pointer hover:scale-105 transition"
            onClick={() => setModalImg(img)}
          />
        ))}
      </div>
      {modalImg !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <button
            className="absolute left-8 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-70 rounded-full p-2 text-2xl font-bold hover:bg-opacity-100"
            onClick={e => {
              e.stopPropagation();
              setModalImg(images[(images.indexOf(modalImg) - 1 + images.length) % images.length]);
            }}
            aria-label="Previous image"
          >&#8592;</button>
          <img src={modalImg} alt="Modal" className="max-h-[80vh] max-w-[90vw] rounded shadow-lg" onClick={e => e.stopPropagation()} />
          <button
            className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-70 rounded-full p-2 text-2xl font-bold hover:bg-opacity-100"
            onClick={e => {
              e.stopPropagation();
              setModalImg(images[(images.indexOf(modalImg) + 1) % images.length]);
            }}
            aria-label="Next image"
          >&#8594;</button>
          <button
            className="absolute top-8 right-8 bg-white bg-opacity-70 rounded-full p-2 text-2xl font-bold hover:bg-opacity-100"
            onClick={() => setModalImg(null)}
            aria-label="Close modal"
          >&#10005;</button>
        </div>
      )}
      <h2 className="text-2xl font-bold mb-4">Videos</h2>
      <div className="flex flex-wrap gap-8 justify-center">
        {videos.map((vid, i) => (
          vid.type === "youtube" ? (
            <iframe
              key={i}
              width="320"
              height="180"
              src={vid.src}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="rounded shadow"
            ></iframe>
          ) : (
            <video key={i} width="320" height="180" controls className="rounded shadow">
              <source src={vid.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )
        ))}
      </div>
    </div>
  );
}
export default Gallery;
